<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> {{ scope.appVersion }}
  </div>
  <strong>Copyright &copy; <a href="https://gauss-ai.jp">GAUSS,inc</a>.</strong>
  All rights reserved.
</footer>
